import { delay, inject, singleton } from "tsyringe";
import {
  DataWarehouseEventType,
  InstantConfigService,
} from "@identity/services";
import isDebug from "../../utils/is-debug";

@singleton()
export class DataWarehouseTrafficLimiter {
  private cachedValues = new Map<DataWarehouseEventType, boolean>();

  public constructor(
    @inject(delay(() => InstantConfigService))
    private readonly instantConfigService: InstantConfigService,
  ) {}

  public isLimitedTraffic(eventType: DataWarehouseEventType) {
    if (isDebug()) {
      return false;
    }

    if (this.cachedValues.has(eventType)) {
      return this.cachedValues.get(eventType);
    }

    const thresholds = this.instantConfigService.get(
      "dwIdentityTrafficLimits",
      {},
    );
    const eventName = this.getEventName(eventType);

    if (
      thresholds?.[eventName] === undefined ||
      thresholds[eventName] === 100
    ) {
      return false;
    }

    const isLimited = thresholds[eventName] < Math.random() * 100;

    this.cachedValues.set(eventType, isLimited);

    return isLimited;
  }

  private getEventName(eventType: DataWarehouseEventType) {
    return DataWarehouseEventType[eventType] ?? "undefined";
  }
}
